import gql from "graphql-tag"


export const SELECT_PLAN = gql`
    mutation SelectPlan($params: SelectPlanRequest!) {
        selectPlan(params: $params) @client
    }
`